import './index.scss'
import _ from 'lodash'
import download from 'downloadjs'
import { useEffectOnce } from 'react-use'
import { useLocation } from 'react-router-dom'
import { WorkoutResourceTable, WorkoutToolbar } from './components'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { workoutResourceListPromise, workoutResourceCSVPromise } from 'api/WorkoutResource'

const WorkoutResourceList = props => {
  const ref = useRef()
  const location = useLocation()
  const [params, setParams] = useState({})
  const [workoutResources, setWorkoutResources] = useState({})

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  useEffect(() => {
    console.log(params)
  }, [params])

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const { page, sort, ...filter } = Object.fromEntries(foo.entries())
    const sortMap = sort && _.zipObject(['column', 'order'], sort.split(','))

    workoutResourceListPromise({ page, filter, sort: sortMap }).then(resp => setWorkoutResources(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  function handleOrderChange (sort) {
    handleParamsChange({ sort: `${sort.column},${sort.order}` })
  }
  // end

  const fetchWorkoutResources = async () => {
    const res = await workoutResourceCSVPromise(params.filter, params.orderBy, 'csv')
    download(res, 'workouts.csv', 'application/csv');
  }

  return (
    <div className={'root'}>
      <div className={'content'}>
        <WorkoutToolbar
          {...props}
          params={params}
          onSearch={handleParamsChange}
          onExport={fetchWorkoutResources}
        />

        <br />

        <WorkoutResourceTable
          page={params.page}
          data={workoutResources || {}}
          onPageChange={handlePageChange}
          onOrderByChange={handleOrderChange}
          {...props}
        />
      </div>
    </div>
  )
}

export default WorkoutResourceList